import { FlexBox } from "components/Common/FlexBox"
import { useHomePathWithSelectedDate } from "features/meal/hooks"
import { Link, useMatch } from "react-router-dom"
import PATHS from "router/paths"
import styled from "styled-components"

const Wrapper = styled.div<{ $hasBorderBottom: boolean }>`
  padding: 0 var(--app-horizontal-padding);
  --z-index-header: 1;
  z-index: var(--z-index-header);
  position: relative;
  color: #fff;
  background: #05050c;
  padding-top: 6px;

  &::after {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #242424;
    z-index: -1;
    display: ${(props) => (props.$hasBorderBottom ? "block" : "none")};
  }
`

const StyledLink = styled(Link)<{ $isActive?: boolean }>`
  color: #fff;
  font-size: 18px;
  text-decoration: none;
  font-weight: 500;
  height: 38px;
  display: flex;
  align-items: center;
  opacity: ${(props) => (props.$isActive ? 1 : 0.4)};
  position: relative;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      opacity: 1;
    }
  }

  &::after {
    content: "";
    height: 2px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: ${(props) =>
      props.$isActive ? "#2CCCD3" : "transparent"};

    display: ${(props) => (props.$isActive ? "block" : "none")};
  }
`

const TabHeader = () => {
  const homePath = useHomePathWithSelectedDate()
  const isHomePath = !!useMatch(PATHS.app.root)
  const isFavoritePath = !!useMatch(PATHS.app.myFoods.root)
  const isRecipesPath = !!useMatch(PATHS.app.myFoods.recipes)
  const isMySchedulesPath = !!useMatch(PATHS.app.myFoods.schedules)
  const isMyFoodsPaths = isRecipesPath || isMySchedulesPath || isFavoritePath
  const isNutritionTargetPath = !!useMatch(PATHS.app.yourGoal.root)

  return (
    <Wrapper $hasBorderBottom={isHomePath || isNutritionTargetPath}>
      <FlexBox $alignItems="center" $gap={24}>
        <StyledLink to={homePath} $isActive={isHomePath}>
          Diary
        </StyledLink>
        <StyledLink to={PATHS.app.myFoods.root} $isActive={isMyFoodsPaths}>
          My Food
        </StyledLink>
        <StyledLink
          to={PATHS.app.yourGoal.root}
          $isActive={isNutritionTargetPath}
        >
          Nutrition Target
        </StyledLink>
      </FlexBox>
    </Wrapper>
  )
}

export default TabHeader
